<template>
  <div id="dashboard">
    <b-modal
      :active.sync="logoutModalVisible"
      :canCancel="false"
    >
      <logout-modal :pathfinder="pathfinder"></logout-modal>
    </b-modal>
    <section class="topbar">
      <img
        src="@/assets/icons/wilderverse.png"
        class="home-icon"
      >
      <p
        class="logout"
        @click="logoutModalVisible = true"
      >LOGOUT</p>
    </section>

    <section class="pathfinder">
      <avatar
        :pathfinder="pathfinder"
        :style="{ fontSize: '10vw' }"
      ></avatar>
      <img
        src="@/assets/icons/edit.svg"
        class="edit"
        @click="edit()"
      >
    </section>

    <section class="location">
      <current-location-carousel></current-location-carousel>
    </section>

    <section class="location-pathfinders">
      <location-pathfinders></location-pathfinders>
    </section>

    <section class="care-packages">
      <div class="standout">
        <care-package></care-package>
      </div>
    </section>
    <section class="bonding">
      <bond></bond>
    </section>

    <section class="firefly-jars">
      <fireflies></fireflies>
    </section>

    <section class="foot">
      <img src="@/assets/icons/wilderverse-lg.png">
      <img
        src="@/assets/icons/ccmc-lg.png"
        class="ccmc"
      >
    </section>
  </div>
</template>

<script>
  import CurrentLocationCarousel from "@/components/Location/CurrentLocationCarousel.vue";
  import LocationPathfinders from "@/components/Location/LocationPathfinders.vue";
  import Avatar from "@/components/Pathfinder/Avatar.vue";
  import CarePackage from "@/components/CarePackage/CarePackage.vue";
  import Fireflies from "@/components/Fireflies/Fireflies.vue";
  import Bond from "@/components/Bond/Bond.vue";
  import LogoutModal from "@/components/Dashboard/LogoutModal.vue";

  import { mapState, mapActions } from "vuex";

  // TODO Navigate away despawns pathfinder

  export default {
    components: {
      CurrentLocationCarousel,
      LocationPathfinders,
      CarePackage,
      Fireflies,
      Bond,
      Avatar,
      LogoutModal
    },
    data() {
      return {
        logoutModalVisible: false
      };
    },
    computed: {
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder
      })
    },
    methods: {
      ...mapActions(["despawnPathfinder", "setCurrentPathfinder"]),
      edit() {
        this.$router.push({ name: "customize" });
      }
    },
    beforeRouteLeave(to, from, next) {
      this.despawnPathfinder().then(() => {
        if (to.path === "/") {
          this.setCurrentPathfinder(null);
        }

        next();
      });
    }
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";

  #dashboard {
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    overflow-y: scroll;

    background: linear-gradient(
      to bottom,
      $background 50%,
      $secondary 65%,
      $blue 90%
    );

    section {
      padding-left: 1em;
      padding-right: 1em;
    }

    .modal-content {
      max-height: 100vh;
    }

    .topbar {
      display: flex;
      width: 100%;
      align-items: center;
      margin-bottom: 0;
      padding: 0.5em;

      .home-icon {
        width: 30%;
      }

      .logout {
        margin-left: auto;
        font-weight: bold;
        filter: drop-shadow(0px 0px 1em black);
      }
    }

    .pathfinder {
      @include jungle-background;
      background-size: 200% 100%;
      position: relative;

      img.edit {
        color: $primary;
        position: absolute;
        bottom: 15%;
        left: 75%;
      }
    }

    .care-packages,
    .location-pathfinders,
    .bonding,
    .firefly-jars,
    .foot {
      margin-top: 2em;
    }

    .standout {
      background-color: $purple;
      border-radius: 8px;
      padding: 8px;
    }

    .foot {
      display: flex;
      flex-direction: column;

      align-items: center;
      padding-bottom: 5em;

      img {
        width: 100%;
      }

      img.ccmc {
        width: 50%;
        margin-top: 1em;
      }
    }

    @media only screen and (min-width: 600px) {
      section {
        padding-left: 5em;
        padding-right: 5em;
      }

      .topbar {
        padding: 1em;

        .logout {
          font-size: 1.5em;
        }
      }

      .foot {
        img {
          width: 85%;
        }

        img.ccmc {
          width: 45%;
        }
      }
    }
  }
</style>

